import Vue from 'vue';
import AppEmbedded from './components/AppEmbedded.vue';
import store from './store';
import { initializeLibs } from './utils/loader';

Vue.filter('drmenv', (v) => {
  if (!v) return '';
  switch (v.env) {
    case 'DRMtodayOnboard': return 'Onboard';
    case 'DRMtoday_STAGING': return 'Staging';
    case 'DRMtoday_TESTING': return 'Test';
    case 'DRMtoday': return 'Prod';
  }
  return v.env;
});

Vue.filter('shorten', (v) => {
  if (!v) return '';
  return v.substr(0, 33) + '...';
});

Vue.filter('positive', (v) => {
  if (!v) return '';
  return v >= 0 ? v : '';
});

Vue.filter('utcTime', (v) => {
  if (!v) return '';
  return v.toLocaleTimeString ? v.toLocaleTimeString() : v;
});

initializeLibs();

const createVueApp = () => {
  return new Vue({
    el: '#app',
    store,
    render: h => h(AppEmbedded)
  });
};

if (window.location.href.indexOf('http') === 0) {
  createVueApp();
}
